import { Button, Divider, Grid, Typography } from '@mui/material'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import PrimeTable from '../../../components/PrimeTable'
import { forwardRef, useState, useContext } from 'react'
import { metodoPrograma } from '../../../components/api'
import { setSuccess } from '../../../components/alerts'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'
import { PropostaContext } from './index'
import { GlobalContext } from '../../../App'

const TerapiasComplementares = () => {
  const { usuarioLogado } = useContext(GlobalContext)
  const { dadosEdicao, handleSalvar, atualizaTotais, dispatch } =
    useContext(PropostaContext)
  const [reloadComplementar, setReloadComplementar] = useState(false)

  const salvarTerapia = async (values) => {
    const payload = {
      idAtendimento: dadosEdicao.idAtendimento,
      idTerapia: values?.acTerapia?.[0]?.[0],
      vlTotal: values?.vlTotal,
    }

    const resp = await metodoPrograma('salvaTerapia', payload)
    if (resp.status) {
      setReloadComplementar((v) => !v)
      setSuccess('Tipo Atendimento salvo com sucesso!')
      const { vlSubTotal, vlTotal, vlCaucao } = await atualizaTotais(
        dadosEdicao.idAtendimento,
      )

      await handleSalvar({ ...dadosEdicao, vlCaucao, vlSubTotal, vlTotal })
    }
  }

  const excluiTerapia = async (values) => {
    const payload = {
      idAtendimento: values?.[0],
      sqItem: values?.[1],
    }

    const resp = await metodoPrograma('excluiTerapia', payload)

    if (resp.status) {
      setReloadComplementar((v) => !v)
      await atualizaTotais(values?.[0])
      await handleSalvar(dadosEdicao)
    }
  }

  const editarItens = async (linha, close) => {
    const payload = {
      idAtendimento: linha?.[0],
      sqItem: linha?.[1],
      idTerapia: linha?.[2][0][0],
      qtItem: linha?.[3] || 1,
      vlTotal: Number(linha?.[4] || 0),
    }
    const resp = await metodoPrograma('alterarTerapia', payload)

    if (resp.status) setSuccess('Terapia Alterada')
    await atualizaTotais(linha?.[0])

    setReloadComplementar((v) => !v)
    await handleSalvar(dadosEdicao)
    close()
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5">Terapias Complementares</Typography>
          <Divider />
        </Grid>
        <Grid container spacing={2} style={{ padding: 20 }} item xs={12}>
          <Grid item xs={12}>
            {dadosEdicao.idAtendimento && (
              <PrimeTable
                action="listaTerapia"
                codigo="CtrlProposta"
                parametros={{ idAtendimento: dadosEdicao.idAtendimento }}
                head={['Item', 'Valor', '', '']}
                refresh={reloadComplementar}
                line={(item) => [item?.[2]?.[1], item?.[4], '', '']}
                collumnsDateHour={[3]}
                collumnsCurrency={[1]}
                disablePagination
                rows={100000}
                actionResponse={(resp) =>
                  dispatch({
                    type: 'dadosEdicao',
                    field: 'listTerapias',
                    value: resp?.lista || [],
                  })
                }
                editButton={true}
                addButton={true}
                onDelete={{ index: 3, action: excluiTerapia }}
                fastAddComponent={({ values, edit, close }) => (
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <AutoComplete
                        metodo="buscaTerapia"
                        codigo="CtrlProposta"
                        value={values?.acTerapia}
                        name="acTerapia"
                        label="Terapia"
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        size="small"
                        searchParams={{ idUsuario: usuarioLogado.id }}
                        onChange={async (_, val) => {
                          await edit({ value: val, field: 'acTerapia' })
                          await edit({
                            value: val?.[2] || 0,
                            field: 'vlTotal',
                          })
                        }}
                        textFieldProps={{
                          helperText: !values?.acTerapia
                            ? 'Campo Obrigatório!'
                            : '',
                          error: !values?.acTerapia,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <CurrencyField
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        label="Valor"
                        size="small"
                        value={values?.vlTotal}
                        onChange={(v) => edit({ value: v, field: 'vlTotal' })}
                      />
                    </Grid>
                    <Grid
                      item
                      container
                      xs={12}
                      spacing={2}
                      justifyContent="flex-end"
                    >
                      <Grid item xs={12} md={2}>
                        <Button
                          onClick={close}
                          fullWidth
                          variant="contained"
                          color="inherit"
                          style={{ margin: '5px' }}
                        >
                          Cancelar
                        </Button>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Button
                          onClick={() =>
                            !!values?.acTerapia &&
                            salvarTerapia(values) &&
                            close()
                          }
                          variant="contained"
                          fullWidth
                          color="primary"
                          style={{ margin: '5px' }}
                        >
                          Salvar
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                fastEditComponent={({ linha, close, edit }) => (
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <AutoComplete
                        metodo="buscaTerapia"
                        codigo="CtrlProposta"
                        value={linha[2]}
                        name="acTerapia"
                        label="Terapia"
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        size="small"
                        searchParams={{ idUsuario: usuarioLogado.id }}
                        onChange={(_, val) => edit({ value: val, index: 2 })}
                        textFieldProps={{
                          helperText: !linha?.[2] ? 'Campo Obrigatório!' : '',
                          error: !linha?.[2],
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <CurrencyField
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        label="Valor"
                        size="small"
                        value={linha[4]}
                        onChange={(v) => edit({ value: v, index: 4 })}
                        helperText={!linha?.[4] ? 'Campo Obrigatório!' : ''}
                        error={!linha?.[4]}
                      />
                    </Grid>
                    <Grid
                      item
                      container
                      xs={12}
                      spacing={2}
                      justifyContent="flex-end"
                    >
                      <Grid item xs={12} md={2}>
                        <Button
                          onClick={close}
                          fullWidth
                          variant="contained"
                          color="inherit"
                          style={{ margin: '5px' }}
                        >
                          Cancelar
                        </Button>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Button
                          onClick={() =>
                            !!linha?.[4] &&
                            !!linha?.[2] &&
                            editarItens(linha, close) &&
                            close()
                          }
                          variant="contained"
                          fullWidth
                          color="primary"
                          style={{ margin: '5px' }}
                        >
                          Editar
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default forwardRef(TerapiasComplementares)
